import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { type IColumn, Table } from 'shared/ui/TableNew'
import { IconCopyButton, Status, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { DayjsFormats } from 'shared/lib'
import { type IWebhookHistoryRow } from 'entities/Webhook'
import { useWebhookIntegrationContext } from 'pages/settings/pages/integrations/layout/WebhookLayout'
import styles from './styles.module.scss'

export const HistoryTable = observer(() => {
  const { webhooksStore } = useWebhookIntegrationContext()
  const { webhookHistoryStore } = webhooksStore

  const columns: IColumn<IWebhookHistoryRow>[] = useMemo(
    () => [
      {
        field: 'eventKey',
        name: 'Event key',
        width: '222px',
        minWidth: 166,
      },
      {
        field: 'requestUrl',
        name: 'Request URL',
        width: '246px',
        renderRowCell: (row) => (
          <div className={styles.requestUrl}>
            <Typography variant='body-md-regular' ariaLabel='WebhookPage_timePeriod' ellipsis>
              {row.fields.requestUrl}
            </Typography>
            <div onClick={(e) => e.stopPropagation()}>
              <IconCopyButton value={row.fields.requestUrl} className={styles.copyButton} />
            </div>
          </div>
        ),
      },
      {
        field: 'status',
        name: 'Status',
        width: '204px',
        renderRowCell: (row) => {
          const isFiled = row.fields.status === 'failed'
          return (
            <Status
              emphasis='high'
              intent={isFiled ? 'negative' : 'positive'}
              title={isFiled ? 'Failed' : 'Success'}
              icon={isFiled ? 'closeCircle' : 'check2'}
            />
          )
        },
      },
      {
        field: 'createdAt',
        name: 'Created at',
        renderRowCell: (row) => (
          <Typography variant='body-md-regular' ariaLabel='WebhookPage_timePeriod'>
            {uiStore.dayjs(row.fields.createdAt).format(DayjsFormats.fullWithAtDash)}
          </Typography>
        ),
      },
    ],
    []
  )
  return (
    <Table
      ariaLabel={'HistoryTable'}
      store={webhookHistoryStore.tableStore}
      rows={webhookHistoryStore.items}
      columns={columns}
      virtualization
      onRowClick={webhookHistoryStore.onRowClick}
    />
  )
})
